import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  patchMeSettings,
  type PatchMeSettingsParams,
  type PatchMeSettingsResponse,
} from '@services/AccountService';

export type UsePatchMeSettingsParams = {
  mutationOptions?: SWRMutationConfiguration<
    PatchMeSettingsResponse,
    unknown,
    string,
    PatchMeSettingsParams,
    PatchMeSettingsResponse
  >;
};

export const patchMeSettingsMutationKey = 'patch-me-settings';

export const usePatchMeSettings = ({
  mutationOptions,
}: UsePatchMeSettingsParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PatchMeSettingsResponse,
    unknown,
    string,
    PatchMeSettingsParams
  >(
    patchMeSettingsMutationKey,
    (_url, { arg }) => patchMeSettings(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
